import PropTypes from 'prop-types';
import classNames from 'classnames';
import NextImage from 'next/image';
import GlossaryText from '../GlossaryText';
import YouTubeVideo from '../YouTubeVideo/YouTubeVideo';
import styles from './ImageVideo.module.scss';
import { ucFirst } from '../../utils/caseconverters';

const ImageVideo = ({
    image = null,
    videoId = '',
    title = '',
    caption = '',
    size = 'large',
}) => {
    const hasImage = !!image?.url;

    if (!hasImage && !videoId) {
        return null;
    }

    return (
        <figure
            className={classNames(
                styles['ImageVideo'],
                styles['ImageVideo--' + ucFirst(size)]
            )}>
            {hasImage ? (
                <NextImage
                    src={image.url}
                    alt={image.alt || ''}
                    width={image.width}
                    height={image.height}
                    sizes="100vw"
                    className={styles['ImageVideo__Image']}
                    style={{ '--ratio': image.width / image.height }}
                    data-zoomable
                />
            ) : (
                <YouTubeVideo videoId={videoId} title={title} />
            )}
            {!!caption && (
                <figcaption className={styles['ImageVideo__Caption']}>
                    <GlossaryText text={caption} />
                </figcaption>
            )}
        </figure>
    );
};

ImageVideo.propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
    }),
    videoId: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'full']),
};

export default ImageVideo;
